import { Minus, Plus } from '@components/icons'
import cn from 'clsx'
import { FC, useEffect, useState } from 'react'

interface Props {
  quantity: number
  setQuantity: (_value: number) => void
  isLocked?: Boolean
}

const ProductQuantity: FC<Props> = ({ quantity, setQuantity, isLocked }) => {
  const [disabled, setDisabled] = useState(false)
  const increaseQuantity = () => {
    if (isLocked) return;
    setQuantity(quantity + 1)
  }

  const minusQuantity = () => {
    if (isLocked) return;
    setQuantity(quantity - 1)
  }

  useEffect(() => {
    if (quantity <= 1) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [quantity])

  return (
    <div className={cn("border-solid border rounded-sm quantityBox grid grid-flow-col grid-cols-3 px-2", 
      {"border-ui-grey-25": !isLocked},
      {"bg-accent-1 border-accent-2": !!isLocked}
    )}>
      <button
        className={cn(
          'minus flex justify-center items-center',
          {
            disabled: disabled === true,
          },
          { 'cursor-not-allowed': !!isLocked }   
        )}
        onClick={minusQuantity}
        disabled={disabled}
      >
        <Minus width={11} height={11} />
      </button>

      <div className="text-brand-dark-grey text-16 leading-7 flex justify-center items-center">
        {quantity}
      </div>

      <button
        className={cn("flex justify-center items-center", { 'cursor-not-allowed': !!isLocked }  )}
        onClick={increaseQuantity}
      >
        <Plus width={11} height={11} />
      </button>

      <style jsx>
        {`
          .quantityBox {
            width: 132px;
            height: 48px;
          }
          button:focus {
            outline: 0;
          }
        `}
      </style>
    </div>
  )
}

export default ProductQuantity
